<td class="monthsTitleColumn">{{ month.monthOfYear | hisUi }} {{ month.year }}</td>
@for (day of month?.days; track day) {
  <td grid-calendar-day
    #gridcalendarday
    [day]="day"
    [monthId]="month.monthId"
    [monthOfYear]="month.monthOfYear"
    [year]="month.year.toString()"
    class="positionCenter"
    (click)="gridcalendarday.toggleOverlayPanel($event)"
    (dateSelected)="selectMonth($event)">
  </td>
}